import {
  Group,
  Notification as NotificationManTine,
  Button,
  Text,
} from '@mantine/core';
import React, { memo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { notificationsSelector } from '../../reducers/notificationReducer/notificationSelector';
import {
  clearNotificationTimer,
  onRemoveNotification,
  pinNotification,
} from '../../reducers/notificationReducer/action';

function Notification() {
  const notifications = useSelector(notificationsSelector);
  return (
    <Group direction="column" spacing="sm">
      {notifications?.map((notification) => (
        <NotificationItem key={notification?.id} notification={notification} />
      ))}
    </Group>
  );
}

export default memo(Notification);

const NotificationItem = memo(({ notification }) => {
  const { isLoading, title, disallowClose, description, id, isPinned } =
    notification;
  const [isExpanded, setIsExpanded] = useState(false);
  const dispatch = useDispatch();

  // Check if content needs trimming
  const isLongContent =
    typeof description === 'string' && description.length > 100;

  // Show trimmed or full content based on state
  const displayDescription =
    isLongContent && !isExpanded
      ? `${description.substring(0, 100)}...`
      : description;

  const handleExpand = () => {
    if (!isExpanded) {
      // Clear timeout when expanding any notification
      clearNotificationTimer(id);
      dispatch(pinNotification(id));
    }
    setIsExpanded(!isExpanded);
  };

  const handleClose = () => {
    dispatch(onRemoveNotification({ notificationId: id }));
  };

  return (
    <NotificationManTine
      key={id}
      loading={isLoading}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {title}
          {isPinned && (
            <span style={{ fontSize: '10px', opacity: 0.7 }}>📌</span>
          )}
        </div>
      }
      //  disallowClose={disallowClose}
      onClose={handleClose}
      color="indigo"
      styles={{
        body: {
          minWidth: 350,
          maxWidth: isExpanded ? 650 : 300,
          transition: 'all 0.3s ease',
        },
      }}
    >
      <div>
        <div
          style={{
            maxHeight: isExpanded ? '400px' : '80px',
            overflow: 'hidden',
            transition: 'max-height 0.3s ease',
          }}
        >
          <Text
            size="sm"
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              lineHeight: 1.4,
              marginBottom: isLongContent ? 8 : 0,
              // Ensure text is visible
              display: 'block',
            }}
          >
            {displayDescription}
          </Text>
        </div>
        {isLongContent && (
          <Button
            variant="subtle"
            size="xs"
            onClick={handleExpand}
            style={{
              padding: '2px 8px',
              height: 'auto',
              fontSize: '11px',
              marginTop: 4,
            }}
          >
            {isExpanded ? '↑ Show less' : '↓ Show more'}
          </Button>
        )}
      </div>
    </NotificationManTine>
  );
});
